import { useMutation } from '@tanstack/react-query';
import {
  DEMO_FILL_XML_FORM_FROM_UPLOAD_MUTATION_KEY,
  type FillXmlFormDemoFromUploadRequest,
  type FillXmlFormDemoResponse,
} from '../../contracts';
import { fillXmlFormDemoFromUpload } from '../api/templates';

export function useMutateFillXmlFormDemoFromUpload() {
  return useMutation<FillXmlFormDemoResponse, Error, FillXmlFormDemoFromUploadRequest>({
    mutationKey: DEMO_FILL_XML_FORM_FROM_UPLOAD_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillXmlFormDemoFromUpload(request);
      return data;
    },
  });
}
